import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  sellectAll: {
    id: 'scheduleSettingsButton.sellectAll',
    defaultMessage: '{selectedAllSettings, select, true {Odznacz wszystkie} other {Zaznacz wszystkie}}',
  },
});
